import { render, staticRenderFns } from "./IconsLoader.vue?vue&type=template&id=0fbc2b38&scoped=true"
import script from "./IconsLoader.vue?vue&type=script&lang=js"
export * from "./IconsLoader.vue?vue&type=script&lang=js"
import style0 from "./IconsLoader.vue?vue&type=style&index=0&id=0fbc2b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc2b38",
  null
  
)

export default component.exports